var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.57178C9.79086 8.57178 8 10.3626 8 12.5718C8 14.7809 9.79086 16.5718 12 16.5718C14.2091 16.5718 16 14.7809 16 12.5718C16 11.6049 15.6573 10.7184 15.0859 10.0265V11.3389H14.0859V8.33887H17.0859V9.33887H15.8143C16.5535 10.2103 17 11.339 17 12.5718C17 15.3332 14.7614 17.5718 12 17.5718C9.23858 17.5718 7 15.3332 7 12.5718C7 9.81035 9.23858 7.57178 12 7.57178V8.57178Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshMachine);
export default __webpack_public_path__ + "static/media/refresh-machine.eb4106a639ff1742b6bd3ad6fe5fb96f.svg";
export { ForwardRef as ReactComponent };